export const INIT_CART_LIST = "initCartList";
export const DISPATCH_INIT_CART_LIST = "cart/initCartList";
// 新增购物车
export const ADD_CART = "addCart";
export const DISPATCH_ADD_CART = "cart/addCart";
// 从购物车中删除
export const REMOVE_CART = "removeCart";
export const DISPATCH_REMOVE_CART = "cart/removeCart";
